var env = process.env.REACT_APP_NODE_ENV || "development";

var config =
{
  development:
  {
    api:
    {
      api_key: "600043ed4bbaadc65ea3b01262959cf3",
      url: "https://api-dev.clinlife.com.br"
    },
    local_storage:
    {
      user: "user_admin_dashboard",
      auth: "auth_admin_dashboard"
    },
    jwt:
    {
      key: "f626601536ff2a6eff6ffbbf99f34c09"
    },
    permissions:
    {
      users_admin: "cc8731b7c2ae4ab9edb0c0bb736e41f6",
      privacy_policy: "b44cdaa5463fe345c39fe95929205d47",
      terms_of_use: "90cb98cdd563ca82ee6b1c4426f40834",
      legislation_protect_data: "450bf31dc4fde6d1f650a097709ed64c",
      exam_groups: "9607fe77d20a3b5c19ef8d31f62c14b8",
      exam_types: "95eb071fa730620cc8bd3f699c4d706f",
      enterprises: "9e9bce4582518482eebe4f3b09d32e50",
      users_admin_enterprise: "fae9cfa04e9e0b58506d99ecadaa1af8"
    }
  },
  production:
  {
    api:
    {
      api_key: "600043ed4bbaadc65ea3b01262959cf3",
      url: "https://api.clinlife.com.br"
    },
    local_storage:
    {
      user: "user_admin_dashboard",
      auth: "auth_admin_dashboard"
    },
    jwt:
    {
      key: "f626601536ff2a6eff6ffbbf99f34c09"
    },
    permissions:
    {
      users_admin: "cc8731b7c2ae4ab9edb0c0bb736e41f6",
      privacy_policy: "b44cdaa5463fe345c39fe95929205d47",
      terms_of_use: "90cb98cdd563ca82ee6b1c4426f40834",
      legislation_protect_data: "450bf31dc4fde6d1f650a097709ed64c",
      exam_groups: "9607fe77d20a3b5c19ef8d31f62c14b8",
      exam_types: "95eb071fa730620cc8bd3f699c4d706f",
      enterprises: "9e9bce4582518482eebe4f3b09d32e50",
      users_admin_enterprise: "fae9cfa04e9e0b58506d99ecadaa1af8"
    }
  }
};

module.exports = config[env];
